// extracted by mini-css-extract-plugin
export default {"BrocAndDlr":"X4PiyQdyuz","BrocAndDlr_inner":"oCqFY3Cl5U","CTA":"S3AuBosyr6","CTA_btn":"HRA92uZliV","CTA_text":"cSQfYw76Ir"};